/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Share = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 21 17" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M2 4.995v9.003a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-2.003h2v3.002a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h2.999v2h-2a1 1 0 0 0-1 .998zm2.987 7.007s.218-8.618 9-8.618V0L21 5.406l-7.013 5.622V7.19c-4.766 0-6.516.76-9 4.812z" />
      </g>
    </svg>
  </span>
);

Share.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Share.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Share;
